// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__4T0AP","main":"Layout_main__Y-muS"};